<template>
<b-container class="notification-settings-container" v-if="user != null && loaded">
<b-row v-if="!canEditUser()">
	<b-col>
		Sorry, you cannot modify the notifications for this user.
	</b-col>
</b-row>

<b-form @submit="onSubmit" @reset="onReset"  v-if="canEditUser()">
	<h1 class="page-title">Notifications</h1>
	<b-row>
		<b-col>
			<p>Winnipeg Lane Closures will send you notifications about the status of your lane closure requests.
			</p>
			<p><strong>Email notifications</strong>: Please check your trash or spam mailbox when email notifications are sent.</p>
			<p class="web-only"><strong>Push notifications</strong>:  Install the Winnipeg Lane Closures mobile app to have push notifications sent to your Android or IOS device.</p>
			<p class="app-only"><strong>Push notifications</strong>:  Turn ON have push notifications sent to your Android or IOS device.</p>
			<p v-if="!hideWeb"><strong>Web notifications</strong>: We recommend City of Winnipeg administrators turn Web notifications <strong>ON</strong> if you frequently use Winnipeg Lane Closures.</p>
			<p>Receive these notifications when you are the requester or a contact for a lane closure request.<br/>
			Activate the <strong>Include requests NOT assigned to me</strong> checkbox to ALSO receive notifications about  requests assigned to other people in your organization.</p>
		</b-col>
	</b-row>
	<b-row>
		<b-col>
			<h2>Important / Recommended Notifications</h2>
		</b-col>
	</b-row>

	<b-row>
		<b-col>
		<div class="collapsible text-primary">
	<div class="collapse--content collapse show">
	<b-col class="mb-3">
		<user-notification-setting :setting="'lcr-new-message'" :hideWeb="hideWeb" :forceEmail="true" v-model="user.notificationSetting.value" v-on:notificationsetting:update="updateNotificationSetting"></user-notification-setting>
		<user-notification-setting :setting="'lcr-approved'" :hideWeb="hideWeb" v-model="user.notificationSetting.value" v-on:notificationsetting:update="updateNotificationSetting"></user-notification-setting>
		<user-notification-setting :setting="'lc-not-opened'" :hideWeb="hideWeb" v-model="user.notificationSetting.value" v-on:notificationsetting:update="updateNotificationSetting"></user-notification-setting>
		<user-notification-setting :setting="'new-contravention'" :hideWeb="hideWeb" v-model="user.notificationSetting.value" v-on:notificationsetting:update="updateNotificationSetting"></user-notification-setting>
	</b-col>
	</div>
	</div>
	</b-col>
	</b-row>



	<b-row>
		<b-col>
			<h2>Additional Notifications</h2>
			<p>Expand each of the sections below and choose your preferences.</p>
		</b-col>
	</b-row>

	<b-row>
		<b-col>
			<div :class="collapseLcrUpdateNotifications ? 'text-primary collapsible' : 'text-primary collapsible collapsed'">
				<template>
					<div class="collapsible-heading p-0">
						<div class="d-flex flex-nowrap bottom-border">
							<div class="collapsible-heading__value" @click="collapseLcrUpdateNotifications = !collapseLcrUpdateNotifications">
								Updates to Status or Details
							</div>

							<div class="collapsible-heading__toggle">
								<b-button href="#" variant="collapsible" :class="collapseLcrUpdateNotifications ? '' : ' collapsed'" :aria-expanded="collapseLcrUpdateNotifications ? 'true' : 'false'" aria-controls="collapseLcrUpdateNotifications" @click="collapseLcrUpdateNotifications = !collapseLcrUpdateNotifications">
									<span class="when-opened">
										<font-awesome-icon icon="chevron-down" />
									</span>
									<span class="when-closed">
										<font-awesome-icon icon="chevron-right" />
									</span>
								</b-button>
							</div>
						</div>
					</div>
					<b-collapse id="collapseLcrUpdateNotifications" :visible="collapseLcrUpdateNotifications" class="collapse--content">
						<b-col class="mb-3">
							<user-notification-setting :setting="'lcr-updated'" :hideWeb="hideWeb" v-model="user.notificationSetting.value" v-on:notificationsetting:update="updateNotificationSetting"></user-notification-setting>
										<user-notification-setting :setting="'lcr-attachment'" :hideWeb="hideWeb" v-model="user.notificationSetting.value" v-on:notificationsetting:update="updateNotificationSetting"></user-notification-setting>
							<user-notification-setting :setting="'lcr-denied'" :hideWeb="hideWeb" v-model="user.notificationSetting.value" v-on:notificationsetting:update="updateNotificationSetting"></user-notification-setting>
							<user-notification-setting :setting="'lcr-completed'" :hideWeb="hideWeb" v-model="user.notificationSetting.value" v-on:notificationsetting:update="updateNotificationSetting"></user-notification-setting>
							<user-notification-setting :setting="'lcr-cancelled'" :hideWeb="hideWeb" v-model="user.notificationSetting.value" v-on:notificationsetting:update="updateNotificationSetting"></user-notification-setting>
							<user-notification-setting :setting="'lcr-contact-added'" :hideWeb="hideWeb" v-model="user.notificationSetting.value" v-on:notificationsetting:update="updateNotificationSetting"></user-notification-setting>
							<user-notification-setting :setting="'lcr-contact-removed'" :hideWeb="hideWeb" v-model="user.notificationSetting.value" v-on:notificationsetting:update="updateNotificationSetting"></user-notification-setting>
							<user-notification-setting :setting="'new-lcr'" :hideWeb="hideWeb" v-model="user.notificationSetting.value" v-on:notificationsetting:update="updateNotificationSetting"></user-notification-setting>
						</b-col>
					</b-collapse>
				</template>
			</div>
		</b-col>
	</b-row>

		<b-row>
			<b-col>
				<div :class="collapseReminders ? 'text-primary collapsible' : 'text-primary collapsible collapsed'">
					<template>
						<div class="collapsible-heading p-0">
							<div class="d-flex flex-nowrap bottom-border">
								<div class="collapsible-heading__value" @click="collapseReminders = !collapseReminders">
									Reminders
								</div>
								<div class="collapsible-heading__toggle">
									<b-button href="#" variant="collapsible" :class="collapseReminders ? '' : ' collapsed'" :aria-expanded="collapseReminders ? 'true' : 'false'" aria-controls="collapseReminders" @click="collapseReminders = !collapseReminders">
										<span class="when-opened">
											<font-awesome-icon icon="chevron-down" />
										</span>
										<span class="when-closed">
											<font-awesome-icon icon="chevron-right" />
										</span>
									</b-button>
								</div>
							</div>
						</div>
						<b-collapse id="collapseReminders" :visible="collapseReminders" class="collapse--content">
							<b-col class="mb-3 mt-3">
								Be reminded when you should report lanes closed at the start time and re-opened at the completion time.
							</b-col>
							<b-col class="mb-3">
							<user-notification-setting :setting="'lc-reminder-close'" :hideWeb="hideWeb" v-model="user.notificationSetting.value" v-on:notificationsetting:update="updateNotificationSetting"></user-notification-setting>
							<user-notification-setting :setting="'lc-reminder-open'" :hideWeb="hideWeb" v-model="user.notificationSetting.value" v-on:notificationsetting:update="updateNotificationSetting"></user-notification-setting>
							<user-notification-setting :setting="'r-reminder-place'" :hideWeb="hideWeb" v-model="user.notificationSetting.value" v-on:notificationsetting:update="updateNotificationSetting"></user-notification-setting>
							<user-notification-setting :setting="'r-reminder-remove'" :hideWeb="hideWeb" v-model="user.notificationSetting.value" v-on:notificationsetting:update="updateNotificationSetting"></user-notification-setting>
							</b-col>
						</b-collapse>
					</template>
				</div>
			</b-col>
		</b-row>


		<b-row>
			<b-col>
				<div :class="collapseAlerts ? 'text-primary collapsible' : 'text-primary collapsible collapsed'">
					<template>
						<div class="collapsible-heading p-0">
							<div class="d-flex flex-nowrap bottom-border">
								<div class="collapsible-heading__value" @click="collapseAlerts = !collapseAlerts">
									Warnings
								</div>
								<div class="collapsible-heading__toggle">
									<b-button href="#" variant="collapsible" :class="collapseAlerts ? '' : ' collapsed'" :aria-expanded="collapseAlerts ? 'true' : 'false'" aria-controls="collapseAlerts" @click="collapseAlerts = !collapseAlerts">
										<span class="when-opened">
											<font-awesome-icon icon="chevron-down" />
										</span>
										<span class="when-closed">
											<font-awesome-icon icon="chevron-right" />
										</span>
									</b-button>
								</div>
							</div>
						</div>
						<b-collapse id="collapseAlerts" :visible="collapseAlerts" class="collapse--content">
							<b-col class="mb-3 mt-3">
								Be notified when closures have not been reported at the start or completion times.
							</b-col>
							<b-col class="mb-3">
							<user-notification-setting :setting="'lc-not-closed'" :hideWeb="hideWeb" v-model="user.notificationSetting.value" v-on:notificationsetting:update="updateNotificationSetting"></user-notification-setting>
							<user-notification-setting :setting="'lc-not-opened'" :hideWeb="hideWeb" v-model="user.notificationSetting.value" v-on:notificationsetting:update="updateNotificationSetting"></user-notification-setting>
							<user-notification-setting :setting="'r-not-placed'" :hideWeb="hideWeb" v-model="user.notificationSetting.value" v-on:notificationsetting:update="updateNotificationSetting"></user-notification-setting>
							<user-notification-setting :setting="'r-not-removed'" :hideWeb="hideWeb" v-model="user.notificationSetting.value" v-on:notificationsetting:update="updateNotificationSetting"></user-notification-setting>
							</b-col>
						</b-collapse>
					</template>
				</div>
			</b-col>
		</b-row>

		<b-row>
			<b-col>
				<div :class="collapseReports ? 'text-primary collapsible' : 'text-primary collapsible collapsed'">
					<template>
						<div class="collapsible-heading p-0">
							<div class="d-flex flex-nowrap bottom-border">
								<div class="collapsible-heading__value" @click="collapseReports = !collapseReports">
									Reported Opening/Closing of Lanes and Turning Restrictions
								</div>
								<div class="collapsible-heading__toggle">
									<b-button href="#" variant="collapsible" :class="collapseReports ? '' : ' collapsed'" :aria-expanded="collapseReports ? 'true' : 'false'" aria-controls="collapseReports" @click="collapseReports = !collapseReports">
										<span class="when-opened">
											<font-awesome-icon icon="chevron-down" />
										</span>
										<span class="when-closed">
											<font-awesome-icon icon="chevron-right" />
										</span>
									</b-button>
								</div>
							</div>
						</div>
						<b-collapse id="collapseReports" :visible="collapseReports" class="collapse--content">
							<b-col class="mb-3 mt-3">
								Be notified when lanes are reported closed at the start and re-opened at completion.
							</b-col>
							<b-col class="mb-3">
							<user-notification-setting :setting="'lc-closed'" :hideWeb="hideWeb" v-model="user.notificationSetting.value" v-on:notificationsetting:update="updateNotificationSetting"></user-notification-setting>
							<user-notification-setting :setting="'lc-opened'" :hideWeb="hideWeb" v-model="user.notificationSetting.value" v-on:notificationsetting:update="updateNotificationSetting"></user-notification-setting>
							<user-notification-setting :setting="'r-placed'" :hideWeb="hideWeb" v-model="user.notificationSetting.value" v-on:notificationsetting:update="updateNotificationSetting"></user-notification-setting>
							<user-notification-setting :setting="'r-removed'" :hideWeb="hideWeb" v-model="user.notificationSetting.value" v-on:notificationsetting:update="updateNotificationSetting"></user-notification-setting>
							</b-col>
						</b-collapse>
					</template>
				</div>
			</b-col>
		</b-row>

	<b-row class="notification-settings__playSoundToggle app-only">
	<b-col class="pt-1" md="auto">
	    <label for="toggleMyAlltoggleMyAllSound"><strong>Play a sound for all Push Notifications</strong></label>
	</b-col>
	<b-col md="auto">
	    <div class="on-off-switch-field">
	            <input id="toggleMyAlltoggleMyAllSound" class="on-off-switch" :checked="notifyAllSound"  value="1" type="checkbox" @change="toggleNotifyAllSound()">
	            <label for="toggleMyAlltoggleMyAllSound"></label>
	    </div>
	</b-col>
	</b-row>




<b-row>
	<b-col class="mt-3">
		<b-button variant="primary" type="button" @click="onSubmit">Save <b-spinner small label="Saving..." class="ml-2" v-if="saving"></b-spinner></b-button>
	</b-col>
</b-row>

<b-modal centered v-model="showRequiredFieldModal" type="info" @confirm="showRequiredFieldModal = false">
	<template v-slot:modal-title>{{$t('errors.errorsOccurred')}}</template>
	<ul>
		<li v-for="requiredField in modalRequiredFieldList" v-bind:key="'reqfield'+requiredField">{{$t(requiredField)}}</li>
	</ul>
	<template slot="footer">
		<b-button :disabled="isButtonDisabled" colour="light" :value="$t('labels.ok')" @click="modalRequiredFieldClose" />
	</template>
</b-modal>

<!-- leaving page -->
<b-modal centered id="unsaved-changes-error-modal" title="Unsaved Changes" size="lg" v-model="showUnsavedChangesModal" @ok="modalOnCancel()">
	<p class="is-size-6">{{ $t('messages.unsavedChanges') }}</p>
	<template v-slot:modal-footer="{ ok }">
		<!-- <b-button variant="primary"  type="button" @click="modalOnSave">{{$t('labels.save')}} <b-spinner small label="Saving..." class="ml-2" v-if="saving"></b-spinner></b-button> -->
		<b-button variant="danger" type="button" @click="modalOnLeave">{{$t('labels.leaveAnyway')}}</b-button>
		<b-button variant="secondary"  type="button" @click="modalOnCancel">{{$t('labels.stay')}}</b-button>
	</template>
</b-modal>

</b-form>
</b-container>
<Spinner v-else />
</template>


<script>
import User from '../models/User';
import BootstrapField from '../utility/BootstrapField';
import ErrorHandler from '../utility/ErrorHandler';
import Format from '../utility/Format';
import UserNotificationSetting from '../components/UserNotificationSetting.vue';

import Spinner from "./../components/Spinner.vue"

import Vue from 'vue'

export default {
  name: 'MyNotifications',
  docTitle: "Notifications - Lane Closures",

  components: {
	Spinner,
	UserNotificationSetting,
  },
  data() {
	return {
		User,
		Format,
		id:null,
		collapseLcrUpdateNotifications: false,
		collapseMainNotifications: false,
		collapseReports: false,
		collapseAlerts: false,
		collapseReminders: false,
		collapseViolations: false,
		collapseOrganizationRequests:false,
		collapseMyRequests:false,
		collapseLcrUpdateNotificationsAll: false,
		collapseMainNotificationsAll: false,
		collapseReportsAll: false,
		collapseAlertsAll: false,
		collapseRemindersAll: false,
		collapseViolationsAll: false,
		collapseOrganizationRequestsAll:false,
		collapseMyRequestsAll:false,
		user: null,
		saving:false,
		organizations:[],
		onSubmitPromiseDeferred: {
			resolve:null,
			reject:null
		},
		showUnsavedChangesModal:false,
		lineIndexError:null,
		isButtonDisabled: false,
		saveState:null,
		modalRequiredFieldList: [],
		selectSupervisor:new BootstrapField({
					value: null,
		}),
		selectAlternate:new BootstrapField({
					value: null,
		}),
		selectAway:new BootstrapField({
					value: null,
		}),
		loaded: false,
		showRequiredFieldModal: false,
		requesterProjectIdOptions: [],
		supervisor: null,
		alternateContact: null,
		awayInfo: null,
		refSearchSupervisor: null,
		refSearchAlternate: null,
		refSearchAway: null,
		show: true,
		showNewOrganizationModal: false,
		organizationInfo:null,
		passwordStrength:0,
		passwordFieldType: "password",
		confirmPasswordStrength:0,
		usernamePrefix:new BootstrapField({
					value: null, required:true,
					validator: function(value) {
						if (value == null || value == "null" || value == "") {
							return false;
						}
						return true;
					},
					invalidMessage: 'Please enter user name prefix',
				}),
	}
	},
	mounted() {
		this.waitForUserId();
   },
	computed: {
		hideWeb: function() {
			if (this.$store.getters.userHasRole('internal_admin_requests') || this.$store.getters.userHasRole('system_admin')) {
				return false;
			}
			return true;
		},
		organizationSuffix: function() {
			if (this.user) {
			if (this.organizationInfo) {
				if (this.organizationInfo.domain) {
					return this.organizationInfo.domain;
				}
			}
			}
			return "";
		},
		notifyAllSound() {
			if (this.user) {
				if (this.user.notificationSetting) {
					for (var x = 0; x < this.user.notificationSetting.value.length; x++) {
						if (this.user.notificationSetting.value[x]) {
							if (
								this.user.notificationSetting.value[x].notifySoundMyLcr == 0 ||
								this.user.notificationSetting.value[x].notifySoundAllLcr == 0) {
								return false;
							}
						}
					}
				}
			}
		    return true;
		},


	},

	watch: {
		'user.organizationId.value':function() {
			this.calculateUserName();
		},
		'usernamePrefix.value':function() {
			this.calculateUserName();
		},
		'user.phone.value':function() {
		}
	},

  methods: {
  	    toggleNotifyAllSound() {
  	    	if (this.user) {
  	    		if (this.user.notificationSetting) {
  	    			var x = 0;
  	    			if(this.notifyAllSound) {
  		    			for (x = 0; x < this.user.notificationSetting.value.length; x++) {
    						this.user.notificationSetting.value[x].notifySoundMyLcr = 0;
    						this.user.notificationSetting.value[x].notifySoundAllLcr = 0;
  		    			}
  	    			} else {
  		    			for (x = 0; x < this.user.notificationSetting.value.length; x++) {
    						this.user.notificationSetting.value[x].notifySoundMyLcr = 1;
    						this.user.notificationSetting.value[x].notifySoundAllLcr = 1;
  		    			}
  		    		}
  	    		}
  	    	}
  	    },
	updateNotificationSetting(data) {
		let i = 0;
		if (this.user) {
			if (this.user.notificationSetting) {

				for (i = 0; i < this.user.notificationSetting.value.length; i++) {
					if (this.user.notificationSetting.value[i].notificationTypeId == data.notificationTypeId) {

						if (data.notifyEmailAllLcr == true || data.notifyEmailAllLcr == 1 ) {
							this.user.notificationSetting.value[i].notifyEmailAllLcr = 1;
						} else {
							this.user.notificationSetting.value[i].notifyEmailAllLcr = 0;
						}
						if (data.notifyEmailMyLcr == true || data.notifyEmailMyLcr == 1 ) {
							this.user.notificationSetting.value[i].notifyEmailMyLcr = 1;
						} else {
							this.user.notificationSetting.value[i].notifyEmailMyLcr = 0;
						}


						if (data.notifyAppAllLcr == true || data.notifyAppAllLcr == 1 ) {
							this.user.notificationSetting.value[i].notifyAppAllLcr = 1;
						} else {
							this.user.notificationSetting.value[i].notifyAppAllLcr = 0;
						}
						if (data.notifyAppMyLcr == true || data.notifyAppMyLcr == 1 ) {
							this.user.notificationSetting.value[i].notifyAppMyLcr = 1;
						} else {
							this.user.notificationSetting.value[i].notifyAppMyLcr = 0;
						}

						if (data.notifySoundAllLcr == true || data.notifySoundAllLcr == 1 ) {
							this.user.notificationSetting.value[i].notifySoundAllLcr = 1;
						} else {
							this.user.notificationSetting.value[i].notifySoundAllLcr = 0;
						}
						if (data.notifySoundMyLcr == true || data.notifySoundMyLcr == 1 ) {
							this.user.notificationSetting.value[i].notifySoundMyLcr = 1;
						} else {
							this.user.notificationSetting.value[i].notifySoundMyLcr = 0;
						}

						if (data.notifyBrowserAllLcr == true || data.notifyBrowserAllLcr == 1 ) {
							this.user.notificationSetting.value[i].notifyBrowserAllLcr = 1;
						} else {
							this.user.notificationSetting.value[i].notifyBrowserAllLcr = 0;
						}
						if (data.notifyBrowserMyLcr == true || data.notifyBrowserMyLcr == 1 ) {
							this.user.notificationSetting.value[i].notifyBrowserMyLcr = 1;
						} else {
							this.user.notificationSetting.value[i].notifyBrowserMyLcr = 0;
						}

					}
				}
			}
		}
	},
	switchPasswordVisibility() {
	this.passwordFieldType = this.passwordFieldType === 'password' ? 'text' : 'password'
	},
	checkRole: function(id) {
		let i = 0;
		if (this.user) {
			if (this.user.roles) {
				for (i = 0; i < this.user.roles.length; i++) {
					if (this.user.roles[i].id == id) {
						this.user.roles.splice(i, 1)
						return true;
					}
					return false;
				}
			}
		}
		return false;
	},
	hasRole: function(id) {
		let i = 0;
		if (this.user) {
			if (this.user.roles) {
				for (i = 0; i < this.user.roles.value.length; i++) {
					if (this.user.roles.value[i].id == id) {
						return true;
					}
				}
			}
		}
		return false;
	},



	canAssignRole: function(id) {
		if (this.$store.getters.userHasRole('internal_admin_requests') || this.$store.getters.userHasRole('system_admin')) {
			return true;
		} else {
			if (this.$store.getters.userHasRole('agency_admin')) {
				if (id == "agency_user" || id == "agency_admin" || id == "agency_supervisor") {
					return true;
				}
			}
		}
		return false;
	},

	canEditUser() {
		if (this.$store.getters.userId() == this.id) {
			return true;
		}
		return false;
	},
	canSetApproval() {
		// can't set your own approvals.
		return false;
	},
	canSetRoles() {
		// Can't set your own roles.
		return false;
	},


	toggleEmailNotification(item) {
		if (item == "toggleEmail") {
			if (this.user.notifyEmailAllLcr.value == 1 && this.user.notifyEmailMyLcr.value == 1) {
				this.user.notifyEmailAllLcr.value = 0;
				this.user.notifyEmailMyLcr.value = 0;
			} else {
				this.user.notifyEmailAllLcr.value = 1;
				this.user.notifyEmailMyLcr.value = 1;
			}
		}
		if (item == "toggleNotifyEmailAllLcr") {
			this.user.notifyEmailAllLcr.value = ! this.user.notifyEmailAllLcr.value;
		}
		if (item == "toggleNotifyEmailMyLcr") {
			this.user.notifyEmailMyLcr.value = ! this.user.notifyEmailMyLcr.value;
		}
	},
	toggleAppNotification(item) {
		if (item == "toggleApp") {
			if (this.user.notifyAppAllLcr.value == 1 && this.user.notifyAppMyLcr.value == 1) {
				this.user.notifyAppAllLcr.value = 0;
				this.user.notifyAppMyLcr.value = 0;
			} else {
				this.user.notifyAppAllLcr.value = 1;
				this.user.notifyAppMyLcr.value = 1;
			}
		}
		if (item == "toggleNotifyAppAllLcr") {
			this.user.notifyAppAllLcr.value = ! this.user.notifyAppAllLcr.value;
		}
		if (item == "toggleNotifyAppMyLcr") {
			this.user.notifyAppMyLcr.value = ! this.user.notifyAppMyLcr.value;
		}
	},
	toggleBrowserNotification(item) {
		if (item == "toggleBrowser") {
			if (this.user.notifyBrowserAllLcr.value == 1 && this.user.notifyBrowserMyLcr.value == 1) {
				this.user.notifyBrowserAllLcr.value = 0;
				this.user.notifyBrowserMyLcr.value = 0;
			} else {
				this.user.notifyBrowserAllLcr.value = 1;
				this.user.notifyBrowserMyLcr.value = 1;
			}
		}
		if (item == "toggleNotifyBrowserAllLcr") {
			this.user.notifyBrowserAllLcr.value = ! this.user.notifyBrowserAllLcr.value;
		}
		if (item == "toggleNotifyBrowserMyLcr") {
			this.user.notifyBrowserMyLcr.value = ! this.user.notifyBrowserMyLcr.value;
		}
	},
	toggleSoundNotification(item) {
		if (item == "toggleSound") {
			if (this.user.notifySoundAllLcr.value == 1 && this.user.notifySoundMyLcr.value == 1) {
				this.user.notifySoundAllLcr.value = 0;
				this.user.notifySoundMyLcr.value = 0;
			} else {
				this.user.notifySoundAllLcr.value = 1;
				this.user.notifySoundMyLcr.value = 1;
			}
		}
		if (item == "toggleNotifySoundAllLcr") {
			this.user.notifySoundAllLcr.value = ! this.user.notifySoundAllLcr.value;
		}
		if (item == "toggleNotifySoundMyLcr") {
			this.user.notifySoundMyLcr.value = ! this.user.notifySoundMyLcr.value;
		}
	},
	setOrganization(val) {
		let x = 0;
		if (typeof val == "object") {
		for (x = 0; x < this.organizations.length; x++) {
				if (val) {
			if (val.id == 	this.organizations[x].id) {

				this.organizationInfo = this.organizations[x];
			}
		}
			}
		} else {
		for (x = 0; x < this.organizations.length; x++) {
			if (val == 	this.organizations[x].id) {
				this.organizationInfo = this.organizations[x];
			}
		}
		}
	},
		getLevelClassName(level) {
		return "level-"+level;
	},
	getFlatTree(option) {
		if (option) {
		if (option.namePath) {
			return Format.pipesToFlatTree(option.namePath);
		} else {
			return option.name;
		}
		}
		return null;
	},

	// required fields notifying modal
	modalRequiredFieldClose(){
		this.showRequiredFieldModal = false;
	},

	calculateUserName() {
		if (this.user && this.user.organizationId.value) {
			this.user.username.value = this.usernamePrefix.value + this.user.organizationId.value.domain;
		} else {
			this.user.username.value = null;
		}
		// TODO: confirm that user name is not taken.
	},
	showErrors(errors){
		this.submissionStatus = 'submission-error';
		this.modalRequiredFieldList = [];
		for(let field in errors) {
			this.modalRequiredFieldList.push(errors[field]);
		}
		this.showRequiredFieldModal = true;
	},

		removeAlternateContact(index) {
			this.alternateContact.splice(index, 1);
		},


		SearchSupervisor(input) {
			return new Promise((resolve, reject) => {
				if (input.length < 1) {
					return resolve([])
				}
				Vue.prototype.$http.get(this.$store.state.apiUrl + '/organization/users/assignable/?q='+encodeURI(input))
					.then(resp => {
						resolve(resp.data)
					})
					.catch(error => {
						if (!ErrorHandler.HasLoginErrorCode(error)) {
							this.showErrors(error.response.data.fields);
						} else {
							ErrorHandler.RedirectToLogin();
						}
						reject(error)
					})
			})
		},
		SearchSupervisorValue(result) {
			return result.firstName
		},
		// Addeds a transaction line with contact attached.
		HandleSelectSupervisor(selected) {
			if (selected) {

				this.supervisor = selected;
				this.user.supervisorUserId.value = parseInt(selected.userId);
				this.$refs.searchSupervisor.value = "";
				/*
				if (this.user.id == selected.userId) {
					this.$refs.searchSupervisor.value = "";
				} else {
					this.supervisor = selected;
					this.user.supervisorUserId.value = parseInt(selected.userId);
					this.$refs.searchSupervisor.value = "";
				}
				*/
			}
		},



		SearchAlternate(input) {
			return new Promise((resolve, reject) => {
				if (input.length < 1) {
					return resolve([])
				}
				Vue.prototype.$http.get(this.$store.state.apiUrl + '/organization/users/assignable/?q='+encodeURI(input))
					.then(resp => {
						resolve(resp.data)
					})
					.catch(error => {
						reject(error)
					})
			})
		},
		SearchAlternateValue(result) {
			return result.firstName
		},
		// Addeds a transaction line with contact attached.
		HandleSelectAlternate(selected) {
			if (selected) {
				if (this.user.id == selected.userId) {
					this.$refs.searchAlternate.value = "";
				} else {
					this.alternateContact = selected;
					this.user.alternateUserId = parseInt(selected.userId);
					this.$refs.searchAlternate.value = "";
				}
			}
		},


		onSubmit(evt) {
			evt.preventDefault()
			let that = this;
			if (this.validateFields()) {
			return new Promise(function(resolve,reject){
				that.onSubmitPromiseDeferred.resolve = resolve;
				that.onSubmitPromiseDeferred.reject = reject;
				that.Save(that.user);
			});
			}
		},
		onReset(evt) {
			evt.preventDefault()
			// Trick to reset/clear native browser form validation state
			this.show = false
			this.$nextTick(() => {
			this.show = true
			})
		},
		Save(t) {
			this.saving = true;

			if (t instanceof User) {
				Vue.prototype.$http({
					method: 'put',
					url: `${this.$store.state.apiUrl}/user/${t.id}?r=${Math.round(Math.random() * Math.pow(10, 6))}`,
					data: t.getRawValue()
				}).then(() => {
					this.saveState = 'success';
					this.submissionStatus = 'submission-success';
					this.SaveSuccess();
					this.onSubmitPromiseDeferred.resolve();
					this.$refs.refAttachments.autoSave();
				}).catch(error => {
					this.saveState = 'fail';
					if (error) {
						if (error.response) {
							if (!ErrorHandler.HasLoginErrorCode(error)) {
									// this.laneClosureRequest.SetErrors(error.response.data);
									this.showErrors(error.response.data.fields);
								} else {
									ErrorHandler.RedirectToLogin();
								}
							}
						}
						this.onSubmitPromiseDeferred.reject();
					}).finally(() => {
						this.isButtonDisabled = false;
						this.saving = false;
					});
			}
		},
		SaveSuccess() {
			// good.
			this.user.saveChanges();
		},

		validateFields() {

			let flag = this.user.validate();
			return flag;
		},


			LoadUser(id = this.id) {
				this.loaded = false;
				// Remove any messages being displayed.
				this.submissionStatus = null;
				this.$store.dispatch('organizationList/loadAssignable', this.$store.getters['organizationList/getParams'])
					.then(() => {
							this.organizations = [];
							let records = this.$store.getters['organizationList/getRecords'];
							if ( records ) {
								records.forEach( item => {
									this.organizations.push(item);
								})
							}

							if (id && Format.TryParseInt(id) > 0) {
								this.GetUser(id);
							}
							else {
								if (this.data) {
									this.user = new User(this.data);
									this.user.saveChanges();
								}
							}


						})
					.catch( error => console.log('error', error) ); // eslint-disable-line
			},
			// Loads user data into the component based on provided id.
			GetUser(id) {
				if (Format.TryParseInt(id)) {
					this.loaded = false;
					Vue.prototype.$http.get(this.$store.state.apiUrl + "/user/" + id + "/edit?r=" + Math.round(Math.random() * Math.pow(10, 6))).then(response => {
						this.user = new User(response.data);
						this.setOrganization(this.user.organizationId.value);

						this.supervisor = response.data.supervisor;
						this.alternateContact = response.data.alternateContact;

						// Set the username prefix...
						let usernameParts = this.user.username.getValue().split("@");
						this.usernamePrefix.value = usernameParts[0];
						this.$nextTick(() => {
							this.GetOrganizations();
							// this.user.saveChanges();
						})
					}).catch(error => {
						if (!ErrorHandler.HasLoginErrorCode(error)) {
							if (error.response && error.response.data) {
								this.loaded = false;
								this.transactionStatus = 'load-error';
								this.errorDetails = error.response.data;
							}
						} else {
							ErrorHandler.RedirectToLogin();
						}
					});
				}
			},

		closeNewOrganizationModal() {
			this.showNewOrganizationModal = false;
		},
		openNewOrganizationModal() {
			this.showNewOrganizationModal = true;
		},
		GetOrganizations() {
			this.$store.dispatch('organizationList/loadEditable', {keywords:null})
				.then(() => {
						this.organizations = [];
						let records = this.$store.getters['organizationList/getRecords'];
						if ( records ) {
							records.forEach( item => {
								this.organizations.push(item);
					if (item.id == this.user.organizationId.value) {
						this.user.organizationId.value = item;
					}
							})
						}
						if (this.user.organizationId.value == null) {
							this.user.organizationId.value = this.organizations[0];
						}
						this.loaded = true;
					})
				.catch( error => console.log('error', error) ); // eslint-disable-line
		},


		waitForUserId() {
			this.id = this.$store.getters.userId();

			if (!this.id) {
				window.setTimeout(this.waitForUserId, 100);
			} else {
				this.LoadUser();
			}
		},

		modalOnCancel() {
			this.showUnsavedChangesModal = false;
			if (this.$store.getters.logoutRequested) {
				this.$store.commit('logoutRequested', false);
			}
		},
	}, // end of methods();

	beforeRouteEnter(to, from, next) {
		next(vm => {
			Vue.prototype.$bus.$emit("map:clear", 1);
			Vue.prototype.$bus.$emit("map:toggle", 0);
	});
	},

	beforeRouteLeave(to, from, next) {
		if (this.loaded && this.user.hasChanges()) {
			if (this.overrideUnsavedChanges) {
				next(true);
			} else {
				this.showUnsavedChangesModal = true;
				this.modalOnSave = (function() {
					this.onSubmit().then(() => {
						next(true);
					}).catch(() => {
						next(false);
					});
				}).bind(this);

				this.modalOnLeave = (function() {
					this.showUnsavedChangesModal = false;
					next(true);
				}).bind(this);

				next(false);
			}
		}
		else {
			next(true);
		}
	},

}
</script>
<i18n>
{
	"en-CA": {

	}
}

</i18n>